// @ts-expect-error untyped import
import { createAction } from 'flux-actions';
import * as ActionTypes from 'MeetingsAdmin/redux/actions/ActionTypes';
import { createRequestAction } from 'MeetingsBase/utils/actions';
import { createRpcClientV2 } from 'rpc-client-utils';
import { createCustomConfirmationForLinkRpc } from 'MeetingsAdmin/__generated__/chirp/com/hubspot/meetings/rpc/CustomEmailRpc';
import http from 'hub-http/clients/apiClient';
import { mapAvatarOptionToImageOption } from 'MeetingsLib/utils/email';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const fetchCustomConfirmationEmailSucceeded = createRequestAction(ActionTypes.FETCH_CUSTOM_CONFIRMATION_EMAIL_SUCCEEDED, response => response);
export const putCustomConfirmationEmailFailed = createRequestAction(ActionTypes.PUT_CUSTOM_CONFIRMATION_EMAIL_FAILED, error => ({
  error
}));
export const putCustomConfirmationEmailStarted = createRequestAction(ActionTypes.PUT_CUSTOM_CONFIRMATION_EMAIL_STARTED);
export const putCustomConfirmationEmailSucceeded = createRequestAction(ActionTypes.PUT_CUSTOM_CONFIRMATION_EMAIL_SUCCEEDED, response => response);
export const putCustomConfirmationEmail = (linkId, customConfirmationEmail, {
  bubbleErrors
} = {
  bubbleErrors: true
}) => async dispatch => {
  dispatch(putCustomConfirmationEmailStarted());
  const imageOption = mapAvatarOptionToImageOption(customConfirmationEmail.avatarOption);
  const requestPayload = Object.assign({
    linkId,
    title: customConfirmationEmail.title,
    imageOption: imageOption,
    subject: customConfirmationEmail.subject,
    body: customConfirmationEmail.body
  }, imageOption === 'CUSTOM' && customConfirmationEmail.avatarUrl ? {
    customImageUrl: customConfirmationEmail.avatarUrl
  } : {});
  try {
    await chirpClient.call(createCustomConfirmationForLinkRpc, {
      request: requestPayload
    });
    dispatch(putCustomConfirmationEmailSucceeded(customConfirmationEmail));
  } catch (error) {
    dispatch(putCustomConfirmationEmailFailed(error));
    if (bubbleErrors) throw error;
  }
};
export const stageCustomConfirmationEmailBody = createAction(ActionTypes.STAGE_CUSTOM_CONFIRMATION_EMAIL_BODY, body => body);
export const stageCustomConfirmationEmailSubject = createAction(ActionTypes.STAGE_CUSTOM_CONFIRMATION_EMAIL_SUBJECT, subject => subject);
export const stageCustomConfirmationEmailTitle = createAction(ActionTypes.STAGE_CUSTOM_CONFIRMATION_EMAIL_TITLE, title => title);
export const stageCustomConfirmationEmailAvatar = createAction(ActionTypes.STAGE_CUSTOM_CONFIRMATION_EMAIL_AVATAR, (key, value) => ({
  key,
  value
}));
export const resetCustomConfirmationEmail = createAction(ActionTypes.RESET_CUSTOM_CONFIRMATION_EMAIL);